import { GridColDef, GridRenderCellParams, renderEditDateCell } from '@mui/x-data-grid-premium';
import { dateCell } from 'components/cells';
import { dateFilterOperators } from 'components/enhanced';
import { createColumns } from 'components/enhanced/data-grid/utils';
import { useTranslation } from 'react-i18next';
import { IActivity } from './types';

export function ActivitiesColumns(): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<IActivity>(
    [
      {
        field: 'name'
      },
      {
        field: 'description',
        headerName: t(`global.description`),
        minWidth: 200
      },
      {
        field: 'expertise',
        minWidth: 150
      },
      {
        field: 'monthly_percentage',
        minWidth: 150
      },
      {
        field: 'monthly_hours'
      },
      {
        field: 'output_number',
        minWidth: 150
      },
      {
        field: 'content_type',
        width: 180,
        headerName: t(`entities.cost_element.content_type`),
        sortable: true,
        filterable: false,
        renderCell: (params: GridRenderCellParams) => {
          return (
            params.value && (
              <div>
                <b className="text-secondary-500">{t(`global.${params.value}`)}</b>
              </div>
            )
          );
        }
      },
      {
        field: 'object_id',
        headerName: t(`entities.cost_element.object_id`),
        filterable: false,
        sortable: false,
        width: 150
      },
      {
        field: 'date_start',
        headerName: t(`global.date_start`),
        renderEditCell: renderEditDateCell,
        width: 150,
        renderCell: dateCell
      },
      {
        field: 'date_end',
        headerName: t(`global.date_end`),
        editable: true,
        filterOperators: dateFilterOperators,
        renderEditCell: renderEditDateCell,
        width: 150,
        renderCell: dateCell
      }
    ],
    t,
    'entities.activity'
  );
}
